import React from 'react';
import UserLoginStatusInfolet from './UserLoginStatusInfolet';

const Header = () => {
  return (
    <header className="header">
      <h1>Festivaleer Admin</h1>
      <div className="user-info">
        <UserLoginStatusInfolet />
      </div>
    </header>
  );
};

export default Header;
